import { render, staticRenderFns } from "./SearchTip.vue?vue&type=template&id=3bc90c9e&scoped=true"
import script from "./SearchTip.vue?vue&type=script&lang=ts"
export * from "./SearchTip.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SearchTip.vue?vue&type=style&index=0&id=3bc90c9e&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3bc90c9e",
  "e5d900e6"
  
)

export default component.exports